import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapCodeSnippetSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapcodesnippet: {
      group: 'block',
      // 0-1 button, followed by 0-1 caption, followed by 1 body
      content: 'madcapcodesnippetcopybutton? madcapcodesnippetcaption? madcapcodesnippetbody',
      parseDOM: [{ tag: 'MadCap\\:codeSnippet' }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:codeSnippet',
      specContent: 'madcapcodesnippetcopybutton madcapcodesnippetbody'
    },

    madcapcodesnippetcopybutton: {
      parseDOM: [{ tag: 'MadCap\\:codeSnippetCopyButton' }],
      toDOM(node) {
        const outputSpec = nodeToDOM(node);
        outputSpec.dom.textContent = 'Copy';
        return outputSpec;
      },
      tagName: 'MadCap:codeSnippetCopyButton',
      isVoid: true,
      specContext: 'madcapcodesnippet'
    },

    madcapcodesnippetcaption: {
      group: 'block',
      content: 'block+',
      fillIfContentDeleted: 'mcCentralContainer',
      parseDOM: [{ tag: 'MadCap\\:codeSnippetCaption' }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:codeSnippetCaption'
    },

    madcapcodesnippetbody: {
      group: 'block',
      content: 'text*',
      attrs: {
        'MadCap:useLineNumbers': { default: undefined },
        'MadCap:lineNumberStart': { default: undefined },
        'MadCap:continue': { default: undefined }
      },
      code: true, // Preserves line-breaks during editing
      parseDOM: [{
        tag: 'MadCap\\:codeSnippetBody',
        preserveWhitespace: 'full',
        getAttrs(dom) {
          return getSchemaAttrs(dom, ['MadCap:useLineNumbers', 'MadCap:lineNumberStart', 'MadCap:continue']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:codeSnippetBody'
    }
  } satisfies Record<string, NodeSpec>;
}
